export const BCR_SELECTABLE_HEADER_DESIGNS = ["form", "balanced"] as const;
export type BcrSelectableHeaderDesign = typeof BCR_SELECTABLE_HEADER_DESIGNS[number];

export const DEFAULT_BCR_HEADER_DESIGN: BcrSelectableHeaderDesign = "form";

export const BCR_CLASSIC_LOGO_LAYOUTS = ["both", "left"] as const;
export type BcrClassicLogoLayout = typeof BCR_CLASSIC_LOGO_LAYOUTS[number];
export const DEFAULT_BCR_CLASSIC_LOGO_LAYOUT: BcrClassicLogoLayout = "both";

export const BCR_CLASSIC_LOGO_LAYOUT_OPTIONS = [
  { value: "both", label: "Two logos (left and right)" },
  { value: "left", label: "One logo (left only)" },
];

export function normalizeBcrClassicLogoLayout(value: unknown): BcrClassicLogoLayout {
  return value === "left" ? "left" : DEFAULT_BCR_CLASSIC_LOGO_LAYOUT;
}

export const BCR_HEADER_DESIGN_OPTIONS = [
  { value: "form", label: "Form Header (Default)" },
  { value: "balanced", label: "Classic Header" },
];

export function normalizeBcrHeaderDesign(value: unknown): BcrSelectableHeaderDesign {
  // Preserve an existing Classic selection from the first version of the switch.
  return value === "balanced" || value === "original" ? "balanced" : DEFAULT_BCR_HEADER_DESIGN;
}

export function getBcrHeaderPreviewDirectory(value: unknown): string {
  return normalizeBcrHeaderDesign(value) === "balanced"
    ? "/bcr-display-previews-2"
    : "/bcr-display-previews";
}
